import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const RelatedModal = ({ viewingBookmark, relatedBookmarks, onClose }) => (
  <Dialog open={!!viewingBookmark} onOpenChange={onClose}>
    <DialogContent className="modal-dark sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE]">Related Bookmarks</DialogTitle>
      </DialogHeader>
      <div className="py-4">
        {viewingBookmark && (
          <div className="mb-4 p-3 bg-[rgba(232,160,48,0.04)] border border-[rgba(232,160,48,0.1)]">
            <p className="text-[11px] text-[#F5ECD0] line-clamp-2">{viewingBookmark.message_content}</p>
          </div>
        )}
        {relatedBookmarks.length === 0 ? (
          <p className="text-sm text-[#4A3A1A] text-center py-4">No related bookmarks found. Save more content to discover connections.</p>
        ) : (
          <div className="space-y-3 max-h-[400px] overflow-auto">
            {relatedBookmarks.map((rb, i) => (
              <div key={rb.bookmark_id} className="p-3 border border-[rgba(232,160,48,0.08)] hover:border-[rgba(232,160,48,0.2)] transition-colors" data-testid={`related-bookmark-${i}`}>
                <p className="text-[11px] text-[#F5ECD0] line-clamp-2 mb-1">{rb.message_content}</p>
                {rb.annotation && <p className="text-[10px] text-[#C8600A]">{rb.annotation}</p>}
                <div className="flex items-center justify-between mt-2">
                  <span className="font-mono text-[8px] text-[#4A3A1A]">{Math.round(rb.relevance * 100)}% match</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);
